import { render, staticRenderFns } from "./AdminTrainingDeleteDialog.vue?vue&type=template&id=30290d2a"
import script from "./AdminTrainingDeleteDialog.vue?vue&type=script&lang=js"
export * from "./AdminTrainingDeleteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports